import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {Publisher} from '../../shared/domain/publisher.model';
import {PublisherFileUpload} from '../../shared/domain/publisher-file-upload.model';
import {PublisherFilesService} from '../../shared/services/publisher-files.service';
import {GlobalSpinnerService} from '../../shared/components/loader-service/global-spinner.service';
import {SnackBarService} from '../../shared/services/snackbar.service';

@Component({
  selector: 'cm-publisher-app-import-upload-dialog',
  template: `
    <div mat-dialog-title style=" display: flex; justify-content: space-between;align-items: center;">
      <span>Import Apps</span>
      <mat-icon [matTooltip]="data.schema">info</mat-icon>
    </div>
    <div mat-dialog-content>
      <form #f="ngForm" class="d-flex flex-column">
        <cm-upload-button *ngIf="!editMode" (fileSelected)="this.file = $event"
                          (fileCanceled)="this.file = null"></cm-upload-button>

      </form>

    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
      <button mat-raised-button class="iconed" color="primary" [disabled]="!editMode && !file" (click)="save()">
        <i class="fas fa-save"></i>
        <span>Save</span>
      </button>
    </div>
  `,
})
export class PublisherAppImportUploadDialog implements OnInit {
  file: File;
  description: string;

  editMode: boolean;
  publisherFileUpload: PublisherFileUpload;

  constructor(public dialogRef: MatDialogRef<PublisherAppImportUploadDialog>,
              private service: PublisherFilesService,
              private gss: GlobalSpinnerService,
              private snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.editMode = data.file;
    if (data.file) {
      this.publisherFileUpload = data.file;
    }
  }

  ngOnInit() {
  }

  save() {
    this.gss.showLoader();
    this.service.importAppCsvFile(this.file).subscribe(next => {
      this.gss.hideLoader();
      this.snackBarService.success('File uploaded successfully!');
      this.dialogRef.close(true);
    }, () => {
      this.gss.hideLoader();
      this.snackBarService.error('Error occurred during file upload, please try again.');
    })
  }
}
